import React from "react";

export interface InputGroupProps {
	children: React.ReactNode;
	fullWidth?: boolean;
	className?: string;
}

export const InputGroupAddon: React.FC<{
	children: React.ReactNode;
	className?: string;
}> = ({ children, className = "" }) => (
	<span className={["ds-input-group__addon", className].filter(Boolean).join(" ")}>
		{children}
	</span>
);

export const InputGroup: React.FC<InputGroupProps> = ({
	children,
	fullWidth = false,
	className = "",
}) => (
	<div
		className={[
			"ds-input-group",
			fullWidth ? "ds-input-group--full" : "",
			className,
		]
			.filter(Boolean)
			.join(" ")}
	>
		{children}
	</div>
);
